export default __webpack_public_path__ + "static/media/2176.ceb2d215.png";